var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b-modal', {
    attrs: {
      "id": "addGroupNotesModal",
      "modal-class": "group-details-modal",
      "centered": "",
      "size": "md",
      "hide-footer": "",
      "no-close-on-backdrop": "",
      "hide-header-close": ""
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function fn() {
        return [_c('div', {
          staticClass: "view-groups-header"
        }, [_c('h5', {
          staticClass: "modal-title text-center"
        }, [_vm._v("Create Note")]), _c('b-button', {
          staticClass: "btn-container",
          attrs: {
            "variant": "close-btn"
          },
          on: {
            "click": _vm.closeModal
          }
        }, [_c('i', {
          staticClass: "fas fa-times"
        })])], 1)];
      },
      proxy: true
    }])
  }, [_c('b-container', [_c('div', {
    staticClass: "form-part"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('label', {
    attrs: {
      "for": "noteInput"
    }
  }, [_vm._v("Notes "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.note,
      expression: "note"
    }],
    staticClass: "groupSearch-field w-100 mt-2",
    attrs: {
      "id": "noteInput",
      "rows": "4",
      "placeholder": "Enter your note here..."
    },
    domProps: {
      "value": _vm.note
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.note = $event.target.value;
      }, function ($event) {
        _vm.noteError = '';
      }]
    }
  }), _vm.noteError ? _c('div', {
    staticClass: "form-error error-font-size mt-2"
  }, [_vm._v(" " + _vm._s(_vm.noteError) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "mb-3"
  }, [_c('label', {
    attrs: {
      "for": "noteInput"
    }
  }, [_vm._v("Mark Note As "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])]), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.status,
      expression: "status"
    }],
    staticClass: "groupSearch-field mark-fields w-100 mt-2",
    attrs: {
      "id": "noteInput"
    },
    on: {
      "change": function change($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function (o) {
          return o.selected;
        }).map(function (o) {
          var val = "_value" in o ? o._value : o.value;
          return val;
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0];
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  }, [_vm._v("mark the note")]), _vm._l(_vm.statusColors, function (item, key) {
    return _c('option', {
      key: key,
      style: {
        color: item.color,
        fontWeight: 'bold'
      },
      domProps: {
        "value": item.value
      }
    }, [_vm._v(" " + _vm._s(key) + " ")]);
  })], 2), _vm.markError ? _c('div', {
    staticClass: "form-error error-font-size mt-2"
  }, [_vm._v(" " + _vm._s(_vm.markError) + " ")]) : _vm._e()]), _c('div', {
    staticClass: "mb-3"
  }, [_c('label', [_vm._v("Attachments "), _c('span', {
    staticClass: "text-muted"
  }, [_vm._v("(optional)")])]), _c('div', {
    staticClass: "file-upload-container mt-2",
    class: {
      'drag-over': _vm.isDragOver
    },
    on: {
      "click": _vm.triggerFileInput,
      "dragover": function dragover($event) {
        $event.preventDefault();
        return _vm.onDragOver.apply(null, arguments);
      },
      "dragleave": function dragleave($event) {
        $event.preventDefault();
        return _vm.onDragLeave.apply(null, arguments);
      },
      "drop": function drop($event) {
        $event.preventDefault();
        return _vm.onDrop.apply(null, arguments);
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-upload upload-icon"
  }), _c('span', [_vm._v("Click or drag & drop a file here")]), _c('input', {
    ref: "fileInput",
    staticClass: "d-none",
    attrs: {
      "type": "file",
      "accept": ".pdf,.doc,.docx,.xls,.xlsx,.csv"
    },
    on: {
      "change": _vm.handleFile
    }
  })]), _c('div', {
    staticClass: "text-muted small mt-1"
  }, [_vm._v(" Maximum file size: 4MB. Allowed types: pdf, doc, docx, xls, xlsx, csv. ")]), _vm.fileName ? _c('div', {
    staticClass: "mt-2 file-view-template"
  }, [_c('span', [_vm._v(" " + _vm._s(_vm.fileName) + " ")]), _c('i', {
    staticClass: "fa fa-trash excel-trash-icon",
    on: {
      "click": _vm.removeFile
    }
  })]) : _vm._e()]), _c('div', {
    staticClass: "notes-action-btns d-flex justify-content-end flex-column flex-md-row mt-4 gap-2"
  }, [_c('button', {
    staticClass: "group-univ-btn m-0",
    attrs: {
      "disabled": _vm.isLoading
    },
    on: {
      "click": _vm.saveNote
    }
  }, [_vm._v(" " + _vm._s(_vm.isLoading ? "Saving..." : "Submit") + " ")]), _c('b-button', {
    attrs: {
      "variant": "outline-secondary"
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("Close")])], 1)])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }